import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnDestroy } from '@angular/core';
import { GridComponent } from '@progress/kendo-angular-grid';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Global } from '../common/global';
import { SessionService } from '../services/session/session.service';
var CompanySelectorComponent = /** @class */ (function () {
    function CompanySelectorComponent(sessionService, changeDetectorRef) {
        var _this = this;
        this.sessionService = sessionService;
        this.changeDetectorRef = changeDetectorRef;
        this.companies = [];
        this.selectedCompanyIdChange = new EventEmitter();
        this.visibleChange = new EventEmitter();
        this.companyChange = new EventEmitter();
        this.visibleValue = false;
        this.comboBoxData = [];
        this.pageSize = 30;
        this.skip = 0;
        this.selectedRows = [];
        this.companyId = -1;
        this.pageable = true;
        this.gridData = [];
        this.filterSubject = new BehaviorSubject('');
        this.ngUnsubscribe = new Subject();
        this.filterSubject
            .asObservable()
            .pipe(debounceTime(300), distinctUntilChanged())
            .subscribe(function (value) { return _this.applyFilter(value); });
    }
    Object.defineProperty(CompanySelectorComponent.prototype, "selectedCompanyId", {
        get: function () {
            return this.selectedCompanyIdValue;
        },
        set: function (value) {
            if (this.selectedCompanyIdValue !== value) {
                this.selectedCompanyIdValue = value;
                this.selectedCompanyIdChange.emit(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanySelectorComponent.prototype, "visible", {
        get: function () {
            return this.visibleValue;
        },
        set: function (value) {
            var _this = this;
            if (this.visibleValue !== value) {
                this.visibleValue = value;
                this.visibleChange.emit(value);
                if (value) {
                    if (this.hasMultiCompanyModule) {
                        this.companies.forEach(function (company) {
                            company.DisplayName =
                                company.Name + (Global.SESSION.HasBackendAccess ? ' (' + company.Id + ')' : '');
                        });
                        this.companies.sort(this.compareByCompanyName);
                        this.gridData = this.companies;
                        if (!this.isMobile) {
                            setTimeout(function () { return _this.filterInput.nativeElement.focus(); });
                        }
                    }
                    else {
                        this.companies.forEach(function (company) {
                            company.DisplayName =
                                (company.Name.length < 30 ? company.Name : company.Name.substring(0, 30) + '...') +
                                    (Global.SESSION.HasBackendAccess ? ' (' + company.Id + ')' : '');
                        });
                        this.companies.sort(this.compareByCompanyName);
                        this.comboBoxData = this.companies;
                    }
                }
                else {
                    this.gridData = [];
                    this.comboBoxData = [];
                    this.filterValue = '';
                    this.selectedRows = [];
                    this.filter = '';
                }
                this.loadItems();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanySelectorComponent.prototype, "filter", {
        get: function () {
            return this.filterValue;
        },
        set: function (value) {
            this.filterValue = value;
            this.filterSubject.next(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanySelectorComponent.prototype, "hasMultiCompanyModule", {
        get: function () {
            return this.sessionService.feature.hasModuleId(20) || this.HasBackendAccess;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanySelectorComponent.prototype, "HasBackendAccess", {
        get: function () {
            return Global.SESSION && Global.SESSION.HasBackendAccess;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanySelectorComponent.prototype, "isMobile", {
        get: function () {
            return this.sessionService.browser.isMobile;
        },
        enumerable: true,
        configurable: true
    });
    CompanySelectorComponent.prototype.ngAfterViewInit = function () {
        // this.selectedRows[0] = Global.COMPANY.Id;
    };
    CompanySelectorComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    CompanySelectorComponent.prototype.compareByCompanyName = function (company1, company2) {
        if (company1.DisplayName.toLowerCase() < company2.DisplayName.toLowerCase()) {
            return -1;
        }
        if (company1.DisplayName.toLowerCase() > company2.DisplayName.toLowerCase()) {
            return 1;
        }
        return 0;
    };
    CompanySelectorComponent.prototype.onFilterKeyUp = function (event) {
        var _this = this;
        if (event.key === 'Enter') {
            this.choseCompany();
            event.stopPropagation();
            event.preventDefault();
        }
        else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            if (this.gridView.data && this.gridView.data.length > 0) {
                var rowIndex = this.grid.activeRow && this.grid.activeRow.index
                    ? this.grid.activeRow.index
                    : this.selectedRows && this.selectedRows.length > 0
                        ? this.gridView.data.indexOf(this.gridView.data.find(function (model) { return model.Id === _this.selectedRows[0]; })) + 1
                        : 0;
                rowIndex = event.key === 'ArrowUp' ? (rowIndex = rowIndex - 1) : (rowIndex = rowIndex + 1);
                if (rowIndex > this.gridView.data.length + 1) {
                    rowIndex = 1;
                }
                if (this.gridView.data[rowIndex - 1]) {
                    this.selectedRows = [this.gridView.data[rowIndex - 1].Id];
                }
                else {
                    this.selectedRows = [this.gridView.data[0].Id];
                    this.grid.focusCell(0, 0);
                }
            }
        }
        else if (event.key === 'Escape') {
            this.visible = false;
        }
    };
    CompanySelectorComponent.prototype.choseCompany = function () {
        var _this = this;
        if (this.selectedRows && this.selectedRows.length === 1) {
            this.companyId = this.selectedRows[0];
            var companyafterfilter = this.gridView.data.find(function (model) { return model.Id === _this.companyId; });
            if (companyafterfilter) {
                this.emitCompanyId(this.companyId);
                return;
            }
        }
        if (this.gridView.data.length === 1) {
            this.companyId = this.gridView.data[0].Id;
            this.emitCompanyId(this.companyId);
        }
        else {
            this.selectedRows = this.gridView.data && this.gridView.data.length > 0 ? [this.gridView.data[0].Id] : [];
        }
    };
    CompanySelectorComponent.prototype.onDialogEnter = function (event) {
        if (event.key === 'Enter') {
            this.choseCompany();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    CompanySelectorComponent.prototype.onGridKeyUp = function (event) {
        var _this = this;
        if (event.key === 'Enter') {
            this.choseCompany();
            event.stopPropagation();
            event.preventDefault();
        }
        else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            if (this.selectedRows && this.selectedRows.length > 0 && this.gridView.data && this.gridView.data.length > 0) {
                var rowIndex = this.selectedRows && this.selectedRows.length > 0
                    ? this.gridView.data.indexOf(this.gridView.data.find(function (model) { return model.Id === _this.selectedRows[0]; })) + 1
                    : 0;
                rowIndex = event.key === 'ArrowUp' ? (rowIndex = rowIndex - 1) : (rowIndex = rowIndex + 1);
                if (rowIndex > this.gridView.data.length + 1) {
                    rowIndex = 1;
                }
                if (this.gridView.data[rowIndex - 1]) {
                    this.selectedRows = [this.gridView.data[rowIndex - 1].Id];
                }
                else {
                    this.selectedRows = [this.gridView.data[0].Id];
                    this.grid.focusCell(0, 0);
                }
            }
        }
        else if (event.key === 'Escape') {
            this.visible = false;
        }
    };
    CompanySelectorComponent.prototype.onCellClick = function (event) {
        this.companyId = event.dataItem.Id;
        this.emitCompanyId(this.companyId);
    };
    CompanySelectorComponent.prototype.pageChange = function (event) {
        this.skip = event.skip;
        this.loadItems();
    };
    CompanySelectorComponent.prototype.emitCompanyId = function (companyId) {
        var _this = this;
        setTimeout(function () {
            _this.companyChange.emit(companyId);
            _this.selectedCompanyId = companyId;
            _this.visible = false;
        });
    };
    CompanySelectorComponent.prototype.applyFilter = function (value) {
        if (this.companies) {
            if (value) {
                var searchText_1 = value.toLocaleLowerCase();
                this.gridData = this.companies.filter(function (c) {
                    return (c.VatRegistrationNumber && c.VatRegistrationNumber.toLocaleLowerCase().includes(searchText_1)) ||
                        c.DisplayName.toLocaleLowerCase().includes(searchText_1) ||
                        (c.Id && c.Id.toString().includes(searchText_1)) ||
                        (c.SecondaryVatRegistrationNumber && c.SecondaryVatRegistrationNumber.toString().includes(searchText_1));
                });
            }
            else {
                this.gridData = this.companies;
            }
        }
        this.skip = 0;
        this.loadItems();
    };
    CompanySelectorComponent.prototype.loadItems = function () {
        this.gridView = {
            data: this.gridData.slice(this.skip, this.skip + this.pageSize),
            total: this.gridData.length
        };
        if (this.gridView.total <= this.pageSize) {
            this.pageable = false;
        }
        else {
            this.pageable = true;
        }
        this.changeDetectorRef.markForCheck();
        this.changeDetectorRef.detectChanges();
    };
    return CompanySelectorComponent;
}());
export { CompanySelectorComponent };
